'use strict';

import RequestData from 'Data/RequestData';
import UserData from 'Data/UserData';
import GenericTableData from './GenericTableData';

// Request Approval Requests Module Event Bus. Handles all interactions with Request Approval Requests.
let RequestApprovalRequestsData = GenericTableData.getTableDataBus(
  'RAR',
  'request_approval_requests',
);

RequestApprovalRequestsData.sendApprovalEmails = (request, rars) => {
  let emailPromises = rars.map((rar) => {
    UserData.getRecord(rar.approver_id).then((approver) => {
      return RequestData.sendApprovalRequestEmail(request, approver);
    });
  });

  return Promise.allSettled(emailPromises);
};
export default RequestApprovalRequestsData;
